import React, { useEffect, useState, useRef } from 'react';

const MemoryPalaceNarrative = ({ narrative, currentSegment, onSegmentComplete }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio());

  useEffect(() => {
    if (narrative[currentSegment]) {
      const text = narrative[currentSegment];
      
      const ssmlText = `<speak>
        <prosody rate="0.97" pitch="+2st">
          ${text}
        </prosody>
      </speak>`;

      fetch('https://texttospeech.googleapis.com/v1/text:synthesize', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_GOOGLE_CLOUD_API_KEY}`
        },
        body: JSON.stringify({
          input: { ssml: ssmlText },
          voice: {
            languageCode: 'en-US',
            name: 'en-US-Studio-O',  // Using the newer Studio voice
            ssmlGender: 'FEMALE'
          },
          audioConfig: {
            audioEncoding: 'MP3',
            effectsProfileId: ['large-home-entertainment-class-device'],
            pitch: 0,
            speakingRate: 1,
            volumeGainDb: 0,
            naturalSampleRateHertz: 24000
          }
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.audioContent) {
          const audioContent = data.audioContent;
          const blob = new Blob(
            [Uint8Array.from(atob(audioContent), c => c.charCodeAt(0))],
            { type: 'audio/mp3' }
          );
          const url = URL.createObjectURL(blob);
          
          audioRef.current.src = url;
          audioRef.current.play();
          setIsPlaying(true);
        } else {
          console.error('No audio content in response:', data);
        }
      })
      .catch(error => {
        console.error('Error with Text-to-Speech API:', error);
        // Fallback to browser's speech synthesis
        const utterance = new SpeechSynthesisUtterance(text);
        window.speechSynthesis.speak(utterance);
      });
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
      }
      setIsPlaying(false);
    };
  }, [currentSegment, narrative]);

  useEffect(() => {
    const audio = audioRef.current;
    
    audio.onended = () => {
      setIsPlaying(false);
      onSegmentComplete();
    };

    return () => {
      audio.onended = null;
    };
  }, [onSegmentComplete]);

  return (
    <div className="narrative-container">
      <div className="narrative-text">
        {narrative.map((segment, index) => (
          <p 
            key={index}
            className={`narrative-segment ${index === currentSegment ? 'active' : ''}`}
          >
            {segment}
          </p>
        ))}
      </div>
      {isPlaying && (
        <div className="audio-indicator">
          <div className="audio-wave"></div>
          <span>Speaking...</span>
        </div>
      )}
    </div>
  );
};

export default MemoryPalaceNarrative; 